import React from 'react';

import { Typography, useUiLabel } from '@canvas-logic/clp-shared-ui';
import type { UiLabelKey } from '@canvas-logic/clp-api-types';


import RequestSuccessIcon from './icons/request-ok.svg?react';
import RequestErrorIcon from './icons/request-bad.svg?react';
import RequestPendingIcon from './icons/request-sending.svg?react';

import styles from './RequestQuote.module.css';

const statusData: Record<
  'pending' | 'success' | 'error',
  { titleKey: UiLabelKey; textKey: UiLabelKey; icon: React.ReactElement }
> = {
  pending: {
    titleKey: 'ui.requestQuote.pending.title',
    textKey: 'ui.requestQuote.pending.text',
    icon: <RequestPendingIcon />,
  },
  success: {
    titleKey: 'ui.requestQuote.success.title',
    textKey: 'ui.requestQuote.success.text',
    icon: <RequestSuccessIcon />,
  },
  error: {
    titleKey: 'ui.requestQuote.error.title',
    textKey: 'ui.requestQuote.error.text',
    icon: <RequestErrorIcon />,
  },
};

export const RequestQuoteFormStatus = ({ status }: { status: 'pending' | 'error' | 'success' }) => {
  const data = statusData[status];
  const titleLabel = useUiLabel(data.titleKey);
  const textLabel = useUiLabel(data.textKey);

  return (
    <div className={styles.formStatusContainer}>
      <div className={styles.statusIcon}>{data.icon}</div>
      <div className={styles.statusText}>
        <Typography variant="heading5" component="div">
          {titleLabel}
        </Typography>
        <Typography variant="paragraph-sm" color="description">
          {textLabel}
        </Typography>
      </div>
    </div>
  );
};
